export enum TextareaSize {
  Default = 'default',
  Small = 'small',
  Large = 'large'
}
